import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";

const CarouselComp = () => {
    return (
        <div>
            <Carousel className="carousel">
            <Carousel.Item>
                    <img
                        className="flex justify-center items-center img-fluid"
                        src="urboncoBank/banner/banner4.png"
                        alt="Second slide"
                    />
                </Carousel.Item>
                
                <Carousel.Item>
                    <img
                        className="flex justify-center items-center img-fluid"
                        src="urboncoBank/banner/banner3.png"
                        alt="Second slide"
                    />
                </Carousel.Item>
                <Carousel.Item className="w-full">
                    <img
                        className="flex justify-center items-center  img-fluid"
                        src="urboncoBank/banner/banner1.png"
                        alt="First slide"
                    />
                </Carousel.Item>   
                <Carousel.Item className="w-full">
                    <img
                        className="flex justify-center items-center  img-fluid"
                        src="urboncoBank/banner/banner5.png"
                        alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item className="w-full h-[550px]">
                    <img
                        className="flex justify-center items-center   img-fluid"
                        src="urboncoBank/banner/banner6.jpeg"
                        alt="First slide"
                    />
                </Carousel.Item>
                <Carousel.Item className="w-full h-[550px]">
                    <img
                        className="flex justify-center items-center  img-fluid"
                        src="urboncoBank/banner/banner7.jpeg"
                        alt="First slide"
                    />
                </Carousel.Item>
              
                <Carousel.Item className="w-full h-[550px] ">
                    <img
                        className="flex justify-center items-center  img-fluid"
                        src="urboncoBank/banner/banner8.jpeg"
                        alt="First slide"
                    />
                </Carousel.Item>
            </Carousel>
        </div>
    );
};

export default CarouselComp;
